import { REGISTERED_APPS } from '../../shared/types/Apps';
import { getCheckoutButtonSelectors } from '../domUtils';
import DocumentListenerUtilsBase from '../documentListenerUtilsBase';

export default class CandyCartDocumentListenerUtils extends DocumentListenerUtilsBase {
  constructor(eventName: string) {
    super(eventName, REGISTERED_APPS.CANDYCART);
  }

  selectors(): string {
    return getCheckoutButtonSelectors();
  }
}
